export const licenceText = {
  header: 'Detalle de licencia y planes',
  description:
    'Aquí podrás conocer todos los detalles sobre el plan que has adquirido. Te explicaremos cómo funciona, sus características principales, y te daremos un vistazo a los beneficios que ofrece, así como a los aspectos a tener en cuenta. Queremos que tengas toda la información para que aproveches al máximo tu plan y tomes decisiones informadas.',
  acceptTermsText:
    'Aceptas que has leído y comprendido la información sobre las licencias',
  tooltipTitle: '¿Para qué es esto?',
  tooltipMessage:
    'Debes leer la información de cada licencia para que tengas el conocimiento de los beneficios que tiene cada una y asi aproveches el plan o selecciones el que más se adapte a tus necesidades.',
};
